// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 593 ? "framework" : chunkId) + "-" + {"81":"89cfe4952b9518b958d3","88":"abc122d631913f054613","249":"41d0e0ca4af268c61f6a","323":"459db2cae48526f37e8a","593":"0670d067d0dbab051377"}[chunkId] + ".js";
};